import React, { useRef, useEffect, useState } from 'react'
import { Button } from 'semantic-ui-react'
import './Modal.css'
export interface IConfirmationModalProps {
  onConfirm?: () => void
  onCancel?: () => void
  confirmText: string
  cancelText: string
  title: string
  isOpen: boolean
  hideCancelButton: boolean
}
const PopupModal: React.FunctionComponent<IConfirmationModalProps> = ({
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  title,
  isOpen,
  hideCancelButton,
  children,
}) => {
  const modalRef = useRef(null)
  const [, setIsOpen] = useState(false)

  useEffect(() => {
    if (isOpen) {
      const modalElement = modalRef.current
      //add any focusable HTML element you want to include to this string
      const focusableElements = modalElement.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      const handleTabKeyPress = (event) => {
        if (event.key === 'Tab') {
          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault()
            lastElement.focus()
          } else if (
            !event.shiftKey &&
            document.activeElement === lastElement
          ) {
            event.preventDefault()
            firstElement.focus()
          }
        }
      }

      const handleEscapeKeyPress = (event) => {
        if (event.key === 'Escape') {
          setIsOpen(false)
        }
      }

      modalElement.addEventListener('keydown', handleTabKeyPress)
      modalElement.addEventListener('keydown', handleEscapeKeyPress)

      return () => {
        modalElement.removeEventListener('keydown', handleTabKeyPress)
        modalElement.removeEventListener('keydown', handleEscapeKeyPress)
      }
    }
  }, [isOpen, setIsOpen])

  return isOpen ? (
    <>
      <div className="modal" ref={modalRef}>
        <div>
          <span> <b> {title}</b></span>
          <hr />
          <p></p>
          <p></p>
          <span>{children}</span>

          <hr />

          <div className="modal__box">
            <p></p>

            <p></p>
            {hideCancelButton ? (
              <></>
            ) : (
              <Button
                content={cancelText}
                onClick={onCancel}
                className="is-secondary modal__box__children"
                autoFocus={true}
              ></Button>
            )}
            <Button
              content={confirmText}
              onClick={onConfirm}
              autoFocus={true}
              className="is-secondary modal__box__childrennpm"
            />
          </div>
        </div>
      </div>
    </>
  ) : (
    <></>
  )
}

export default PopupModal
